import * as Sentry from "@sentry/react";

/**
 * Reporte de errores a Sentry (org `sozu-lh`, proyecto `sozu-admin`).
 *
 * El DSN va en el código, igual que en las apps: es público (solo permite
 * ENVIAR eventos a este proyecto, no leer nada), así que no hay variable que
 * dar de alta. En `pnpm dev` no se inicializa: local no reporta.
 *
 * El release lo inyecta `@sentry/vite-plugin` en el build de CI (SHA del
 * commit), así que aquí no se fija.
 *
 * El panel maneja datos de clientes: el SDK v11 recolecta todo por default, y
 * aquí se apaga lo que pueda traer datos personales (bodies, query params,
 * cookies, usuario). Replays apagados por lo mismo.
 */
const SENTRY_DSN =
  "https://4e99517c3b8855aacbf5393d28407fe3@o4512302460895232.ingest.us.sentry.io/4512323875176448";

export function iniciarSentry() {
  if (import.meta.env.DEV) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    // VITE_ENVIRONMENT es lo que ya separa los builds (`production` en main);
    // el modo de Vite queda de respaldo para builds locales.
    environment: import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: { request: { allow: ["content-type"] }, response: false },
      httpBodies: [],
      urlQueryParams: false,
      graphQL: { document: false, variables: false },
      genAI: { inputs: false, outputs: false },
      mcp: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      stackFrameVariables: false,
    },
  });
}

export { Sentry };
